import { ContentWrapper, DataTable } from "@components/index";
import {
  Button,
  Col,
  Dropdown,
  Input,
  Menu,
  Pagination,
  Row,
  Select,
  Space,
  Spin,
  TableColumnsType,
  Tabs,
  Typography,
} from "antd";
import React, { useCallback, useEffect, useState } from "react";
import { get } from "@services/api.service";
import { get as _get } from "lodash";
import { useNotification } from "@hooks/useNotification";
import { useNavigate, useSearchParams } from "react-router-dom";
import moment from "moment";
import { useMaskId } from "~/Hooks/useMaskId";
import { useHasAccess } from "@hooks/useHasAccess";
import { Icon } from "@iconify/react";
import { permissions } from "@utils/Roles";
import { getColoriezedValue, getColorizedValueDocuSign } from "~/Utils/getColorizedValue";
import { useQuery } from "~/Hooks/useQuery";
import { useAuth } from "@hooks/useAuth";
import { defaultCurrencyCode, formatToDecimal, UserType } from "~/Utils";
import { debounce } from "lodash";
import { getFormattedDate, getKey, getUrlwithParams, hasKeyString, scrollToElement } from "@utils/CommonUtils";
import { FilterDropDown } from "@components/FilterDropDown/FilterDropDown";
import { Watchers } from "../Watchers/Watchers";
import _ from "lodash";
import { stat } from "fs";
import styles from "../Contract.module.scss";
import { spaBudget, spaFilterBudget, spaFilterPaper, spaPaper } from "~/Utils/StringConstants";

export const SPA = () => {
  const [data, setData] = useState<any>([]);
  const [apiUrl, setApiUrl] = useState<any>("");
  const { hasPermissions, hasRole } = useHasAccess();
  const { openToast } = useNotification();
  const [recordsPerPage, setRecordsPerPage] = useState<number>(10);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [isLoading, setIsLoading] = useState(false);
  const [sortOrder, setSortOrder] = useState("desc");
  // const [division, setDivision] = useState<any>("");
  const [amountData, setAmountData] = useState<any>([0, 10000000]);
  // const [subsidiary, setSubsidiary] = useState<any>("");
  const navigate = useNavigate();
  const query = useQuery();
  const { user } = useAuth();
  const [orderByName, setOrderByName] = useState("createdOn");
  // const [pageStart, setPageStart] = useState<number>(parseInt(query.get("spaListPage") || "0") || 0);
  const { mask } = useMaskId();

  const [filterStatus, setFilterStatus] = useState<any>("");
  const [amountRange, setAmountRange] = useState<any>();

  const [searchParams, setSearchParams] = useSearchParams();
  const paramsObj = Object.fromEntries(searchParams.entries());
  const startDate = searchParams.get("startDate");
  const endDate = searchParams.get("endDate");
  let budget: any = searchParams.get("budget");
  const paper = searchParams.get("paper");
  let status = searchParams.get("status");
  const searchText = searchParams.get("searchText");
  const subsidiary = searchParams.get("subsidiary");
  const division: any = searchParams.get("division") ?? "";
  const startAmount = searchParams.get("startAmount");
  const endAmount = searchParams.get("endAmount");
  const spaListPageParam: any = Number(searchParams.get("spaListPage"));
  const spaListPage = !isNaN(Number(spaListPageParam)) ? spaListPageParam : 0;
  const pageParam = Number(searchParams.get("page"));
  const page = !isNaN(Number(pageParam)) ? pageParam : 0;
  const decodedBudget = decodeURIComponent(budget);
  const encodedBudget = encodeURIComponent(budget);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (encodedBudget === "OPEX%20") {
    budget = "OPEX & CAPEX";
  }
  if (status === "In-Progress" || status === "In Progress") {
    status = "In-Progress";
  }
  useEffect(() => {
    if (hasRole(["*"])) {
      if (query.get("watchers")) {
        // navigate(`/spa-watcher?watchers=true&page=${page}`, {
        //   replace: true,
        // });
      }
    }
  }, [page]);

  const handleSearchChange = (value: string, isLoading: boolean) => {
    setSearchParams({ ...paramsObj, searchText: value });
    setIsLoading(isLoading);
  };
  const handleTableSort = (column: any, sortOrder: string) => {
    let order = "";
    if (column.sorter) {
      if (sortOrder === "asc") {
        setSortOrder("desc");
        order = "desc";
      } else if (sortOrder === "desc") {
        setSortOrder("asc");
        order = "asc";
      }
    }
    setOrderByName(column.dataIndex);
    getRecords(order, column.dataIndex, searchText, spaListPage);
  };
  // useEffect(()=>{
  // if(queryBudget){
  //   setBudgetValue(queryBudget)
  // }
  // if(queryPaper){
  //   setPaperValue(queryPaper)
  // }
  // if(queryStatus){
  //   setFilterStatus(queryStatus)
  // }
  // },[queryBudget,queryPaper,queryStatus])

  const [date, setDate] = useState<any>({ from: startDate, to: endDate });

  const watchersSpa = query?.get("watchers") && query?.get("watchers");
  const dashboardSubsidiary = query?.get("subsidiary") && query?.get("subsidiary");
  const dashboardDivision = query?.get("division") && query?.get("division");
  const dashboardAmount = query?.get("amount") && query?.get("amount");
  const dashboardFromdate = query?.get("dateFrom") && query?.get("dateFrom");
  const dashboardTodate = query?.get("dateTo") && query?.get("dateTo");

  useEffect(() => {
    if (dashboardSubsidiary || dashboardDivision || dashboardAmount || dashboardFromdate || dashboardTodate) {
      // setSubsidiary(dashboardSubsidiary);
      // setDivision(dashboardDivision);
      // setDate({ from: dashboardFromdate, to: dashboardTodate });
      const formattedItems = Array.of(dashboardAmount);
      const separateItems = formattedItems.map((item: any) => item?.split(","));
      setAmountData(separateItems.flat(2));
    }
  }, []);

  const getRecords = (sortOrder: string, orderByParam: string, searchString: any, currentPage?: number) => {
    setIsLoading(true);
    let url;
    if (watchersSpa) {
      url = `v1/spa/watcher/document-list?page=${page}&size=${recordsPerPage}&order=${sortOrder}&orderBy=${
        orderByParam === "completedDate" ? "completionDate" : orderByParam
      }&subsidiary=${subsidiary ?? ""}&division=${encodeURIComponent(division) ?? ""}&status=${status ?? ""}&startDate=${
        date?.from ? date.from : ""
      }&startAmount=${startAmount ?? ""}&endAmount=${endAmount ?? ""}&endDate=${
        date?.to ? date.to : ""
      }&searchText=${encodeURIComponent(searchString ?? "")}&awardAndStrategyPaper=${
        paper ?? ""
      }&budget=${encodeURIComponent(budget ?? "")}`;
    } else {
      url = `/v1/spa/create/list?page=${currentPage}&size=${recordsPerPage}&order=${sortOrder}&orderBy=${
        orderByParam === "completedDate" ? "completionDate" : orderByParam
      }&subsidiary=${subsidiary ?? ""}&division=${encodeURIComponent(division) ?? ""}&status=${status ?? ""}&startDate=${
        date?.from ? date.from : ""
      }&startAmount=${startAmount ?? ""}&endAmount=${endAmount ?? ""}&endDate=${
        date?.to ? date.to : ""
      }&searchText=${encodeURIComponent(searchString ?? "")}&awardAndStrategyPaper=${
        paper ?? ""
      }&budget=${encodeURIComponent(budget ?? "")}`;
    }

    setApiUrl(url);

    get(url)
      .then((res: any) => {
        if (res && res.response && res.response.data) {
          setTotalRecords(hasKeyString("watcher") ? res.response.data.totalCount : res.response.data.total);
          let envelopes = res.response.data.records;
          setData(envelopes);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setData([]);
        openToast({
          content: "Getting Contracts failed",
          type: "error",
        });
        setIsLoading(false);
      });
  };

  const [updatedData, setUpdatedData] = useState<any>([]);

  useEffect(() => {
    setUpdatedData(data);
  }, [data]);

  const [reRender, setReRender] = useState(true);

  const fetchDate = useCallback(() => {
    return !!(date && date.to && date.from);
  }, [date]);

  const formatMsToDHM = (ms?: number) => {
    if (!ms || ms <= 0) return <Typography.Text disabled>-</Typography.Text>;

    const days = Math.floor(ms / 86400000);
    ms %= 86400000;

    const hours = Math.floor(ms / 3600000);
    ms %= 3600000;

    const minutes = Math.floor(ms / 60000);

    return `${days}Days, ${hours}Hrs, ${minutes}Min`;
  };

  useEffect(() => {
    setReRender(false);
    // setPageStart(spaListPage);
    getRecords(sortOrder, orderByName, searchText, spaListPage);
  }, [
    budget,
    paper,
    searchText,
    status,
    filterStatus,
    subsidiary,
    division,
    amountData[0],
    amountData[1],
    fetchDate(),
    watchersSpa,
    query,
    query.get("spaListPage"),
  ]);

  function convertToTitleCase(inputString: any) {
    let value;
    if (inputString === "HeadofSubsidiary") {
      value = "Head of Subsidiary";
    } else if (inputString === "airportManager") {
      value = "Airport Manager";
    } else if (inputString === "GCFO/GCOO/COO") {
      value = "GCFO/CFO/CAO/COO";
    } else {
      value = inputString;
    }
    return value;
  }

  const menuClick = (key: string, record: { [key in string]: any }) => {
    if (key === "edit") {
      navigate(`/spa/edit/?envelopId=${record?.envelopeId}`);
    } else if (key === "view") {
      navigate(`/spa/view/${record.envelopeId}?activeTab=contractInformation&enable=resend`);
    }
  };
  const columns: TableColumnsType = [
    {
      title: "Project ID",
      dataIndex: "projectId",
      render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "projectId"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "projectId"
            ? "descend"
            : undefined,
    },
    {
      title: "Project Name",
      dataIndex: "projectTitle",
      render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "projectTitle"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "projectTitle"
            ? "descend"
            : undefined,
    },
    {
      title: "Budget",
      dataIndex: "budget",
      render: (value: any) => value || <Typography.Text>Uncategorized</Typography.Text>,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "budget"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "budget"
            ? "descend"
            : undefined,
    },
    {
      title: "SPA Types",
      dataIndex: "awardAndStrategyPaper",
      render: (value: any) => value || <Typography.Text>Uncategorized</Typography.Text>,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "awardAndStrategyPaper"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "awardAndStrategyPaper"
            ? "descend"
            : undefined,
    },
    {
      title: "Proposed Contract Value",
      dataIndex: "contractValue",
      render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "contractValue"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "contractValue"
            ? "descend"
            : undefined,
    },
    {
      title: "Budget/PTE",
      dataIndex: "amount",
      render: (value: any, record: any) => {
        if (value == 0) {
          return <Typography.Text disabled>-</Typography.Text>;
        }

        return value ? (
          formatToDecimal(value, record?.currencyCode || defaultCurrencyCode)
        ) : (
          <Typography.Text disabled>-</Typography.Text>
        );
      },
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "amount"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "amount"
            ? "descend"
            : undefined,
    },
    {
      title: "Subsidiary / Division",
      dataIndex: "subsidiary",
      render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "subsidiary"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "subsidiary"
            ? "descend"
            : undefined,
    },
    {
      title: "Cost Centre",
      dataIndex: "division",
      render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "division"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "division"
            ? "descend"
            : undefined,
    },
    {
      title: "Owner Name",
      dataIndex: "ownerName",
      render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "ownerName"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "ownerName"
            ? "descend"
            : undefined,
    },
    {
      title: "Owner Email",
      dataIndex: "ownerEmail",
      render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "ownerEmail"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "ownerEmail"
            ? "descend"
            : undefined,
    },
    {
      title: "Approval Authority",
      dataIndex: "authorityGroup",
      render: (value: any) => convertToTitleCase(value),
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "authorityGroup"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "authorityGroup"
            ? "descend"
            : undefined,
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (value: any, record: any) =>
        getColorizedValueDocuSign(value) || <Typography.Text disabled>-</Typography.Text>,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "status"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "status"
            ? "descend"
            : undefined,
    },
    {
      title: "Created At",
      dataIndex: "createdOn",
      render: (value: any) =>
        value ? (
          <Typography.Text>{getFormattedDate(value)}</Typography.Text>
        ) : (
          <Typography.Text disabled>-</Typography.Text>
        ),
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "createdOn"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "createdOn"
            ? "descend"
            : undefined,
    },
    {
      title: "Completed At",
      dataIndex: "completedDate",
      render: (value: any) =>
        value ? (
          <Typography.Text>{getFormattedDate(value)}</Typography.Text>
        ) : (
          <Typography.Text disabled>-</Typography.Text>
        ),
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "completedDate"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "completedDate"
            ? "descend"
            : undefined,
    },
    {
      title: "Turn Over Time",
      dataIndex: "turnOverTimeInMilliSec",
      render: (value: any) => formatMsToDHM(value),
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "turnOverTimeInMilliSec"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "turnOverTimeInMilliSec"
            ? "descend"
            : undefined,
    },
  ];
  if (!watchersSpa) {
    columns.push({
      title: "Action",
      dataIndex: " ",
      render: (value: any, record: any) => {
        const menuItems = [
          {
            label: (
              <span onClick={(e) => e.stopPropagation()}>
                <Typography.Text
                  type="secondary"
                  style={{ color: styles.primary }}
                  onClick={() => navigate(`/spa/view/${record.envelopeId}?activeTab=contractInformation&enable=resend`)}
                >
                  <Space>
                    <Icon
                      icon="akar-icons:eye"
                      inline
                      fontSize={16}
                      style={{ color: styles.primary }}
                    />
                    View
                  </Space>
                </Typography.Text>
              </span>
            ),
            key: "view",
          },
        ];
        if (record?.status === "draft") {
          menuItems.unshift({
            label: (
              <span onClick={(e) => e.stopPropagation()}>
                <Typography.Text
                  onClick={() => navigate(`/spa/edit/?envelopId=${record?.envelopeId}`)}
                  type="secondary"
                  style={{ color: styles.primary }}
                >
                  <Space>
                    <Icon
                      icon="akar-icons:edit"
                      inline
                      fontSize={16}
                      style={{ color: styles.primary }}
                    />
                    Edit
                  </Space>
                </Typography.Text>
              </span>
            ),
            key: "edit",
          });
        }

        return (
          <Dropdown
            overlay={
              <Menu
                onClick={({ key }) => menuClick(key, record)}
                items={menuItems}
              />
            }
            trigger={["click"]}
            placement="bottomLeft"
          >
            <span onClick={(e) => e.stopPropagation()}>
              <Icon
                icon={"bi:three-dots-vertical"}
                style={{ cursor: "pointer" }}
              />
            </span>
          </Dropdown>
        );
      },
    });
  }
  const reviewerColumn: TableColumnsType = [
    {
      title: "Contract ID",
      dataIndex: "projectId",
      render: (value: any, record: any) => value || <Typography.Text disabled>-</Typography.Text>,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "projectId"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "projectId"
            ? "descend"
            : undefined,
    },
    {
      title: "Contract No",
      dataIndex: "contractNumber",
      render: (value: any, record: any) => value || <Typography.Text disabled>-</Typography.Text>,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "contractNumber"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "contractNumber"
            ? "descend"
            : undefined,
    },
    {
      title: "Contract Name",
      dataIndex: "contractName",
      render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "contractName"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "contractName"
            ? "descend"
            : undefined,
    },
    {
      title: "Vendor Name",
      dataIndex: "vendorName",
      render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "vendorName"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "vendorName"
            ? "descend"
            : undefined,
    },
    {
      title: "Creator Name",
      dataIndex: "creatorName",
      render: (value: any, record: any) => value || <Typography.Text disabled>-</Typography.Text>,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "creatorName"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "creatorName"
            ? "descend"
            : undefined,
    },
    {
      title: "Subsidiary/Division",
      dataIndex: "subsidiary",
      render: (value: any, record: any) => value || <Typography.Text disabled>-</Typography.Text>,
      sortOrder:
        sortOrder === "asc" && orderByName === "subsidiary"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "subsidiary"
            ? "descend"
            : undefined,
    },
    {
      title: "Commencement Date",
      dataIndex: "commencementDate",
      render: (value: any) =>
        value ? (
          <Typography.Text>{moment(value).format("DD MMM YYYY")}</Typography.Text>
        ) : (
          <Typography.Text disabled>-</Typography.Text>
        ),
      ellipsis: true,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "commencementDate"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "commencementDate"
            ? "descend"
            : undefined,
    },
    {
      title: "Completed Date",
      dataIndex: "completedDate",
      render: (value: any) =>
        value ? (
          <Typography.Text>{moment(value).format("DD MMM YYYY")}</Typography.Text>
        ) : (
          <Typography.Text disabled>-</Typography.Text>
        ),
      ellipsis: true,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "completedDate"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "completedDate"
            ? "descend"
            : undefined,
    },
    {
      title: "Created Date",
      dataIndex: "createdOn",
      render: (value: any, record: any) =>
        value ? (
          <Typography.Text>{getFormattedDate(value)}</Typography.Text>
        ) : (
          <Typography.Text disabled>-</Typography.Text>
        ),
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "createdOn"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "createdOn"
            ? "descend"
            : undefined,
    },
  ];

  const [clearSearchData, setClearSearchData] = useState(false);
  const [clearFilter, setClearFilter] = useState(false);

  useEffect(() => {
    if (watchersSpa || watchersSpa === null) {
      if (!dashboardSubsidiary && !dashboardDivision && !dashboardAmount && !dashboardFromdate && !dashboardTodate) {
        if (status || division || date || subsidiary || amountData) {
          // setSearchParams({ "status":''});
          // setDivision("");
          // setSubsidiary("");
          // setDate("");
          setAmountData([0, 10000000]);
          setClearSearchData(true);
          setClearFilter(true);
        }
      }
    }
  }, [watchersSpa]);

  useEffect(() => {
    const clearQuery = query.get("status");
    if (clearQuery === null) {
      // setSearchParams({ "status":''});
      // setDivision("");
      // setSubsidiary("");
      // setDate("");
      setAmountData([0, 10000000]);
      setClearSearchData(true);
      setClearFilter(true);
    }
  }, [query]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setClearSearchData(false);
      setClearFilter(false);
    }, 1000);

    return () => clearTimeout(timeoutId);
  }, [isLoading]);

  const reviewerColumnReviewed: TableColumnsType = [
    {
      title: "Contract ID",
      dataIndex: "projectId",
      render: (value: any, record: any) => value || <Typography.Text disabled>-</Typography.Text>,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "projectId"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "projectId"
            ? "descend"
            : undefined,
    },
    {
      title: "Contract No",
      dataIndex: "contractNumber",
      render: (value: any, record: any) => value || <Typography.Text disabled>-</Typography.Text>,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "contractNumber"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "contractNumber"
            ? "descend"
            : undefined,
    },
    {
      title: "Contract Name",
      dataIndex: "contractName",
      render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "contractName"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "contractName"
            ? "descend"
            : undefined,
    },
    {
      title: "Vendor Name",
      dataIndex: "vendorName",
      render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "vendorName"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "vendorName"
            ? "descend"
            : undefined,
    },
    {
      title: "Creator Name",
      dataIndex: "creatorName",
      render: (value: any, record: any) => value || <Typography.Text disabled>-</Typography.Text>,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "creatorName"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "creatorName"
            ? "descend"
            : undefined,
    },
    {
      title: "Subsidiary/Division",
      dataIndex: "subsidiary",
      render: (value: any, record: any) => value || <Typography.Text disabled>-</Typography.Text>,
      sortOrder:
        sortOrder === "asc" && orderByName === "subsidiary"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "subsidiary"
            ? "descend"
            : undefined,
    },
    {
      title: "Signer Status",
      dataIndex: "status",
      render: (value: any, record: any) =>
        getColorizedValueDocuSign(value) || <Typography.Text disabled>-</Typography.Text>,
    },
    {
      title: "Commencement Date",
      dataIndex: "commencementDate",
      render: (value: any) =>
        value ? (
          <Typography.Text>{moment(value).format("DD MMM YYYY")}</Typography.Text>
        ) : (
          <Typography.Text disabled>-</Typography.Text>
        ),
      ellipsis: true,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "commencementDate"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "commencementDate"
            ? "descend"
            : undefined,
    },

    {
      title: "Created Date",
      dataIndex: "createdOn",
      render: (value: any, record: any) =>
        value ? (
          <Typography.Text>{getFormattedDate(value)}</Typography.Text>
        ) : (
          <Typography.Text disabled>-</Typography.Text>
        ),
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "createdOn"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "createdOn"
            ? "descend"
            : undefined,
    },
    {
      title: "Completed Date",
      dataIndex: "completedDate",
      render: (value: any) =>
        value ? (
          <Typography.Text>{getFormattedDate(value)}</Typography.Text>
        ) : (
          <Typography.Text disabled>-</Typography.Text>
        ),
      ellipsis: true,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "completedDate"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "completedDate"
            ? "descend"
            : undefined,
    },
  ];

  const items = [
    {
      label: "Pending for Review",
      key: "pendingReview",
      children: (
        <>
          <DataTable
            columns={reviewerColumn?.map((column) => ({
              ...column,
              onHeaderCell: (column: any) => ({
                onClick: () => {
                  if (column.sorter) {
                    handleTableSort(column, sortOrder);
                  }
                },
              }),
            }))}
            className="table-clickable"
            tableData={
              updatedData
                ? updatedData?.map((d: any, index: number) => {
                    return {
                      ...d,
                      key: getKey(spaListPage, index),
                    };
                  })
                : null
            }
            isLoading={false}
            exportFileName="SPA"
            onClick={(record) => {
              getUrlwithParams();
              navigate(`/spa/view/${record.envelopeId}`);
            }}
            additionalCTA={
              <FilterDropDown
                // setpage={setPageStart}
                clearSearchData={clearSearchData}
                clearFilter={clearFilter}
                viewStatus={false}
                viewDate={true}
                viewSubsidiary={true}
                viewDivisions={true}
                viewBudget={true}
                viewPaper
                // setStatus={setStatus}
                setDate={setDate}
                setAmountRange={setAmountRange}
              />
            }
            totalRecords={totalRecords}
            inputDisable={isLoading}
            isPagination={true}
            // isServerSearchApi={true}
            // spaSearch={true}
            // onSearchChange={handleSearchChange}
            searchPlaceholderText={"Search Contract ID/Name/Number"}
            exportApiUrl={apiUrl}
            recordsPerPage={recordsPerPage}
            tabOffset={60}
          />
          <div className="pagination">
            <Pagination
              defaultCurrent={1}
              current={spaListPage + 1}
              total={totalRecords}
              onChange={(page) => {
                const startIndex = page - 1;
                // setPageStart(startIndex);
                setSearchParams({ ...paramsObj, spaListPage: String(startIndex) });
                getRecords(sortOrder, orderByName, searchText, startIndex);
              }}
              showSizeChanger={false}
            />
          </div>
        </>
      ),
    },
    {
      label: "Reviewed",
      key: "reviewed",
      children: (
        <>
          <DataTable
            columns={reviewerColumnReviewed?.map((column) => ({
              ...column,
              onHeaderCell: (column: any) => ({
                onClick: () => {
                  if (column.sorter) {
                    handleTableSort(column, sortOrder);
                  }
                },
              }),
            }))}
            className="table-clickable"
            onSearchChange={handleSearchChange}
            tableData={
              updatedData
                ? updatedData?.map((d: any, index: number) => {
                    return {
                      ...d,
                      key: getKey(spaListPage, index),
                    };
                  })
                : null
            }
            isLoading={false}
            inputDisable={isLoading}
            isServerSearchApi={true}
            additionalCTA={
              <FilterDropDown
                // setpage={setPageStart}
                clearSearchData={clearSearchData}
                clearFilter={clearFilter}
                viewStatus={true}
                viewDate={true}
                viewDivisions={true}
                viewBudget={true}
                viewPaper
                // setStatus={setStatus}
                setDate={setDate}
                setAmountRange={setAmountRange}
              />
            }
            exportFileName="SPA"
            onClick={(record) => {
              getUrlwithParams();
              navigate(`/spa/view/${record.envelopeId}`);
            }}
            totalRecords={totalRecords}
            isPagination={true}
            searchPlaceholderText={"Search Contract ID/Name/Number"}
            exportApiUrl={apiUrl}
            spaSearch={true}
            recordsPerPage={recordsPerPage}
          />
          <div className="pagination">
            <Pagination
              defaultCurrent={1}
              total={totalRecords}
              current={spaListPage + 1}
              onChange={(page) => {
                const startIndex = page - 1;
                // setPageStart(startIndex);
                setSearchParams({ ...paramsObj, spaListPage: String(startIndex) });
                getRecords(sortOrder, orderByName, searchText, startIndex);
              }}
              showSizeChanger={false}
            />
          </div>
        </>
      ),
    },
  ];

  const statusData: any = [
    { key: "created", title: "Created" },
    { key: "In-Progress", title: "In Progress" },
    { key: "completed", title: "Completed" },
    { key: "cancelled", title: "Cancelled" },
    { key: "rejected", title: "Rejected" },
    { key: "expired", title: "Expired" },
    { key: "draft", title: "Draft" },
  ];

  // const handleStatusChange = (value: any) => {
  //   if (value === undefined) {
  //     setStatus("");
  //     query.delete("status");
  //   } else {
  //     setStatus(value);
  //     query.set("status", value);
  //   }
  //   navigate({ search: query.toString() }, { replace: true });
  // };

  return (
    <ContentWrapper
      className="spa-container"
      title={"Single Party Approval"}
      isMobile={isMobile}
      actionItems={
        <Row
          gutter={12}
          justify="end"
          style={isMobile ? { display: "flex", flexDirection: "column", rowGap: 10 } : undefined}
        >
          <Col span={isMobile ? 24 : 6}>
            {" "}
            <Input
              allowClear
              title=" Search Project ID / Project Name"
              placeholder=" Search Project ID / Project Name"
              value={searchText || ""}
              onChange={(e) => handleSearchChange(e.target.value, true)}
            />
          </Col>
          <Col span={isMobile ? 24 : 5}>
            <Select
              className="w-100"
              placeholder="Select Budget"
              allowClear
              value={budget || undefined}
              onChange={(e) => {
                if (e) {
                  setSearchParams({ ...paramsObj, budget: e });
                } else {
                  setSearchParams({ ...paramsObj, budget: "" });
                }
              }}
            >
              {spaFilterBudget.map((item: any, i: any) => (
                <Select.Option
                  value={item}
                  key={i}
                >
                  {item}
                </Select.Option>
              ))}
            </Select>
          </Col>
          <Col span={isMobile ? 24 : 5}>
            <Select
              className="w-100"
              placeholder="Select SPA Types"
              allowClear
              onClear={() => {
                setSearchParams({ ...paramsObj, paper: "" });
              }}
              value={paper || undefined}
              onChange={(e) => {
                if (e) {
                  setSearchParams({ ...paramsObj, paper: e });
                } else {
                  setSearchParams({ ...paramsObj, paper: "" });
                }
              }}
            >
              {spaFilterPaper.map((item: any, i: any) => (
                <Select.Option
                  value={item}
                  key={i}
                >
                  {item}
                </Select.Option>
              ))}
            </Select>
          </Col>
          <Col
            // style={{ marginRight: hasKeyString("watcher") ? "20px" : "0px" }}
            span={isMobile ? 24 : 5}
          >
            <Select
              className="w-100"
              value={status || undefined}
              placeholder="Select Status"
              onChange={(e) => {
                if (e) {
                  setSearchParams({ ...paramsObj, status: e });
                } else {
                  setSearchParams({ ...paramsObj, status: "" });
                }
              }}
              allowClear
              onClear={() => {
                setSearchParams({ ...paramsObj, status: "" });
              }}
            >
              {statusData.map((item: any, index: any) => (
                <Select.Option
                  key={index}
                  value={item.key}
                >
                  {item.title}
                </Select.Option>
              ))}
            </Select>
          </Col>
          {!hasKeyString("watcher") && (
            <Col span={isMobile ? 24 : 3}>
              <Button
                type="primary"
                className="w-100"
                onClick={() => navigate(`/spa/add`)}
              >
                <Space>
                  <Icon
                    icon="akar-icons:plus"
                    inline
                  />
                  Add
                </Space>
              </Button>
            </Col>
          )}
        </Row>
      }
    >
      {isLoading && (
        <div className="loadingOverlay">
          <Space size="middle">
            <Spin size="large" />
          </Space>
        </div>
      )}
      {hasRole(["SPA_ADMIN,SPA_USER,SPA_REVIEWER"]) ? (
        <Tabs
          activeKey={query?.get("activeTab") || ""}
          items={items}
          onChange={(activeKey) => {
            // setPageStart(0);
            setSearchParams({ ...paramsObj, spaListPage: "0" });
            // setDivision("");
            navigate(`/spa?activeTab=${activeKey}`);
          }}
        ></Tabs>
      ) : (
        <div>
          <DataTable
          isMobile={isMobile}
            columns={columns?.map((column) => ({
              ...column,
              onHeaderCell: (column: any) => ({
                onClick: () => {
                  if (column.sorter) {
                    handleTableSort(column, sortOrder);
                  }
                },
              }),
            }))}
            className="table-clickable"
            tableData={
              updatedData
                ? updatedData?.map((d: any, index: number) => {
                    return {
                      ...d,
                      key: getKey(spaListPage, index),
                    };
                  })
                : null
            }
            additionalCTA={
              <FilterDropDown
                isMobile={isMobile}
                clearSearchData={clearSearchData}
                clearFilter={clearFilter}
                viewStatus={false}
                viewDivisions={true}
                viewDate={true}
                viewBudget={true}
                viewPaper
                setAmountData={setAmountData}
                setDate={setDate}
                setAmountRange={setAmountRange}
              />
            }
            isLoading={false}
            exportFileName="SPA"
            onClick={(record) => {
              if (watchersSpa) {
                navigate(`/spa-watcher/view/${record.envelopeId}?activeTab=contractInformation&enable=return`);
              } else {
                // navigate(`/spa?spaListPage=${spaListPage}`);
                setSearchParams({ ...paramsObj, spaListPage: spaListPageParam });
                navigate(`/spa/view/${record.envelopeId}?activeTab=contractInformation&enable=resend`);
              }
            }}
            isPagination={true}
            // onSearchChange={handleSearchChange}
            inputDisable={isLoading}
            spaSearch={true}
            isServerSearchApi={true}
            totalRecords={totalRecords}
            exportApiUrl={apiUrl}
            recordsPerPage={recordsPerPage}
            searchPlaceholderText={"Search here"}
            tabOffset={24}
          />
          <div
            id="spaList"
            className="pagination"
          >
            <Pagination
              defaultCurrent={watchersSpa ? page : spaListPage}
              total={totalRecords}
              current={watchersSpa ? page + 1 : spaListPage + 1}
              onChange={(page) => {
                const startIndex = page - 1;
                if (watchersSpa) {
                  setSearchParams({ ...paramsObj, page: String(startIndex) });
                  // setPageStartAt(startIndex);
                } else {
                  // setPageStart(startIndex);
                  setSearchParams({ ...paramsObj, spaListPage: String(startIndex) });
                }
                getRecords(sortOrder, orderByName, searchText, startIndex);
              }}
              showSizeChanger={false}
            />
          </div>
        </div>
      )}
    </ContentWrapper>
  );
};
